export const GOOGLE_CLIENT_ID = '218640827671-m7psssbt456nu3tip87t12kpjuf7lhkv.apps.googleusercontent.com';

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyBpJ1ZA6pwYIkK5OsY7JENqyBQjvZJdd5M',
  authDomain: 'wheelseye-178710.firebaseapp.com',
  databaseURL: 'https://wheelseye-178710.firebaseio.com',
  projectId: 'wheelseye-178710',
  storageBucket: 'wheelseye-178710.appspot.com',
  messagingSenderId: '20420679268',
  appId: '1:20420679268:web:b087cab3a9c6f2f7f33171',
  measurementId: 'G-1VSL16MN8L',
};
export const DEBOUNCE_TIME = 800;
